import React, { useEffect, useRef,useState } from "react";
import { Offcanvas, Button } from 'react-bootstrap';

import logo_flavescence from './../assets/images/logo_flavescence.svg';
import logo_fd_wo_bg from './../assets/images/logo-fd-wo-bg.svg';
import loupe from './../assets/images/loupe.svg';
import line_header from './../assets/images/line-header.svg';
import flavescence_menu from './../assets/images/flavescence-menu.jpg';
import {urlBase} from "../config/Globals";
import RubriqueSevice from "../service/RubriqueSevice";

export const Header = ({  openDownloadModal, openSearchModal }) => {

    const [showMenu, setShowMenu] = useState(false);

    const handleCloseMenu = () => setShowMenu(false);
    const handleShowMenu = () => setShowMenu(true);

    const[rubriques, setRubriques] = useState([]);
    const[loadingRubriques, setLoadingRubriques] = useState(1);
    const fetchRubriques = async() => {
        try{
            const data = await RubriqueSevice.findAll();
            setRubriques(data);
            setLoadingRubriques(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchRubriques();
    }, []);

    return (
        <>
            <header className="fixed-top bg-white">
                <nav className="navbar navbar-expand-lg py-3">
                    <div className="container-fluid px-4 px-md-5">

                        <a className="navbar-brand-1 position-absolute start-0 top-0 d-none d-lg-flex align-items-center m-0"
                           href={urlBase}>
                            <img src={logo_flavescence} alt="Flavescence dorée Bourgogne" className="logo-main" />
                        </a>

                        <a className="align-items-center m-0 d-lg-none" href="/">
                            <img src={logo_fd_wo_bg} alt="Flavescence dorée Bourgogne" height="60"/>
                        </a>

                        <a className="navbar-brand-alt align-items-center m-0" href="/">
                            <img src={logo_fd_wo_bg}  alt="Flavescence dorée Bourgogne"
                                 className="logo-sticky" />
                        </a>

                        <div className="cta-header d-flex align-items-center gap-4 ms-auto">

                            <button onClick={openSearchModal} className="p-0 border-0 d-flex align-items-center gap-2 text-black bg-transparent" type="button" data-bs-toggle="modal" data-bs-target="#searchModal">
                                        <img src={loupe} alt="Rechercher" />

                                    <span className="d-none d-sm-inline">Rechercher</span>
                            </button>
                            {!showMenu ? (
                                <button
                                    className="p-0 border-0 d-flex align-items-center gap-2 text-black bg-transparent btn-burger-menu"
                                    type="button" onClick={handleShowMenu}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="21" viewBox="0 0 35 21">
                                        <g transform="translate(-1016.5 -39.5)">
                                            <line x2="31" transform="translate(1018.5 41.5)" fill="none" stroke="#f9c977"
                                                  strokeLinecap="round" strokeWidth="2"></line>
                                        </g>
                                        <g transform="translate(-1016.5 -31.5)">
                                            <line x2="31" transform="translate(1018.5 41.5)" fill="none" stroke="#f9c977"
                                                  strokeLinecap="round" strokeWidth="2"></line>
                                        </g>
                                        <g transform="translate(-1016.5 -23.5)">
                                            <line x2="31" transform="translate(1018.5 41.5)" fill="none" stroke="#f9c977"
                                                  strokeLinecap="round" strokeWidth="2"></line>
                                        </g>
                                    </svg>
                                    <span className="d-none d-sm-inline">Menu</span>
                                </button>
                            ) : (
                                <button
                                    className="p-0 border-0 d-flex align-items-center gap-2 text-black bg-transparent btn-close-menu"
                                    type="button" onClick={handleCloseMenu}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24.749" height="24.749"
                                         viewBox="0 0 24.749 24.749">
                                        <g id="Groupe_2728" data-name="Groupe 2728"
                                           transform="translate(-1021.624 -38.626)">
                                            <line id="Ligne_22" data-name="Ligne 22" x2="31"
                                                  transform="translate(1023.039 40.04) rotate(45)" fill="none"
                                                  stroke="#f9c977" strokeLinecap="round" strokeWidth="2"></line>
                                            <line id="Ligne_40" data-name="Ligne 40" x2="31"
                                                  transform="translate(1044.959 40.04) rotate(135)" fill="none"
                                                  stroke="#f9c977" strokeLinecap="round" strokeWidth="2"></line>
                                        </g>
                                    </svg>
                                    <span className="menu-btn d-none d-sm-inline">Fermer</span>
                                </button>
                                )
                            }
                        </div>
                    </div>
                </nav>
            </header>
            <Offcanvas placement="top" className="border-0" show={showMenu} onHide={handleCloseMenu} style={{ backgroundColor: '#F6F3EB' }}>
                <Offcanvas.Body className="p-0 container-fluid h-100">
                    <div className="row g-0 align-items-stretch h-100">
                        <div className="col-lg-6 my-auto custom-menu-scroll h-100 d-flex flex-column justify-content-center align-items-start px-4 px-md-5">
                            <nav className="navigation-menu-list w-100">
                                <ul className="list-unstyled d-flex flex-column gap-4 style-menu-vignoble m-0">
                                    <li><a href={urlBase+"en-ce-moment-dans-le-vignoble"}
                                           className="fs-4 fw-b text-dark text-decoration-none">En ce moment dans le vignoble</a></li>
                                    <li>
                                        <a href={urlBase+"/tout-savoir-sur-la-flavescence-doree"} className="d-block fs-4 fw-b text-dark text-decoration-none mb-2">Tout savoir sur la flavescence dorée</a>
                                        <ul className="list-unstyled lh-lg">
                                            {
                                                rubriques.map((rubrique, index) => (
                                                        <li key={rubrique.id} ><a href={urlBase + 'tout-savoir-sur-la-flavescence-doree/' + rubrique.wording} className="text-dark text-decoration-none">{rubrique.titre}</a></li>
                                                    )
                                                )
                                            }
                                        </ul>
                                    </li>
                                    <li><a href={urlBase+"faq"}
                                           className="fs-4 fw-b text-dark text-decoration-none">FAQ</a></li>
                                    <li><a href={urlBase+"contact"}
                                           className="fs-4 fw-b text-dark text-decoration-none">Contact</a></li>
                                </ul>
                            </nav>
                            <a href={urlBase+"calendrier-prospection/"} className="btn btn-warning mt-4">Cartes zones de traitement, calendrier de prospection, résultats</a>
                            <a onClick={openDownloadModal} className="text-body text-decoration-underline text-center fw-sb small mt-4 d-xl-none" type="button">Télécharger les plannings et résultats</a>
                        </div>

                        <div className="col-lg-6 d-none d-lg-block bg-image-menu position-relative">
                            <img style={{ width: '170px' , height : '170px' }} src={line_header} alt="Trait" className="position-absolute end-100 top-50 translate-middle-y pe-3 object-fit-contain"/>
                            <img src={flavescence_menu} alt="Accueil" />
                        </div>

                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}